import { AppState } from '@fcom/core/interfaces/app-state.interface';

import { AlternativeOffersState } from './alternative-offers-state.interface';

export const ALTERNATIVE_OFFERS_STATE_FEATURE_NAME = 're-accommodation';

export interface ReaccommodationFeatureState extends AppState {
  [ALTERNATIVE_OFFERS_STATE_FEATURE_NAME]: AlternativeOffersState;
}
